import request from '../utils/request';

export function authorize(data) {
  return request.post('/sso/authorize', data);
}